import { useMutation } from "@tanstack/react-query";
import { BillingApi } from "../api/billing-api";
import {
  CheckoutSessionDto,
  CreateCheckoutSessionDto,
  CustomerPortalDto,
} from "@repo/api/billing";

export function useGenerateCustomerPortalUrl({
  teamExternalId,
  onSuccess,
  onError,
}: {
  teamExternalId: string;
  onSuccess?: (data: CustomerPortalDto) => void;
  onError?: (error: Error) => void;
}) {
  return useMutation({
    mutationKey: billingQueryKeys.generateCustomerPortalUrl(teamExternalId),
    mutationFn: () => BillingApi.generateCustomerPortalUrl(teamExternalId),
    onSuccess,
    onError,
  });
}

export function useCreateCheckoutSession({
  teamExternalId,
  onSuccess,
  onError,
}: {
  teamExternalId: string;
  onSuccess?: (data: CheckoutSessionDto) => void;
  onError?: (error: Error) => void;
}) {
  return useMutation({
    mutationKey: billingQueryKeys.createCheckoutSession(teamExternalId),
    mutationFn: (data: CreateCheckoutSessionDto) =>
      BillingApi.createCheckoutSession(teamExternalId, data),
    onSuccess,
    onError,
  });
}

export const billingQueryKeys = {
  generateCustomerPortalUrl: (teamExternalId: string) => [
    "billing",
    "customer-portal",
    { teamExternalId },
  ],
  createCheckoutSession: (teamExternalId: string) => [
    "billing",
    "checkout-session",
    { teamExternalId },
  ],
};
